<ul class="layout-menu">
  <ng-container *ngFor="let item of model; let i = index;">
      <li sub-menuitem *ngIf="!item.separator" [item]="item" [index]="i" (click)="clicked(i)" [root]="false"></li>
      <li *ngIf="item.separator" class="menu-separator"></li>
  </ng-container>
</ul>